export default __webpack_public_path__ + "static/media/logo.acb24bfb.svg";